import { IconButton } from "@mui/material";
import { useContext, useEffect, useState, useMemo } from "react";
import {
  // attachment_delete,
  attachmentList_vehicle,
} from "src/components/attachments/AttachmentFunctions";
import AttachmentViewer from "src/components/AttachmentViewer/AttachmentViewer";
import { NextIcon, PrevIcon } from "src/components/icons/NavIcons";
import { GridContext } from "src/context/GridContext/GridContext";
import { useUserData } from "src/context/userContext";

export default function GridVehicleInfoModal_Attachment() {
  const { gridVehicleInfoIsOpen, setGridVehicleInfoIsOpen, selectedGridVehicle } =
    useContext(GridContext) || {};
  const { token } = useUserData();

  const [selectedAttachment, setSelectedAttachment] = useState(null);
  const [attachmentList, setAttachmentList] = useState([]);

  useEffect(() => {
    if (!gridVehicleInfoIsOpen) return;
    const asynk = async () => {
      const a = await attachmentList_vehicle(selectedGridVehicle?.vehicleId, token);
      setAttachmentList(a);
      if (a.length > 0) {
        setSelectedAttachment(a[0]);
      } else setSelectedAttachment(null);
    };
    asynk();
  }, [selectedGridVehicle?.vehicleId, setGridVehicleInfoIsOpen]);

  const currentIndex = useMemo(() => {
    if (!attachmentList || attachmentList.length === 0) return -1;
    return attachmentList.findIndex(
      (attachment) => attachment.attachmentId === selectedAttachment?.attachmentId
    );
  }, [attachmentList, selectedAttachment]);

  const nextAttachment = () => {
    if (!attachmentList || attachmentList.length === 0) return;
    const nextIndex = (currentIndex + 1) % attachmentList.length;
    setSelectedAttachment(attachmentList[nextIndex]);
  };

  const prevAttachment = () => {
    if (!attachmentList || attachmentList.length === 0) return;
    const prevIndex = (currentIndex - 1 + attachmentList.length) % attachmentList.length;
    setSelectedAttachment(attachmentList[prevIndex]);
  };

  // const deleteAttachment = async (attachmentId) => {
  //   const a = await attachment_delete(attachmentId, token);
  //   if (a) {
  //     const newAttachmentList = attachmentList.filter(
  //       (attachment) => attachment.attachmentId !== attachmentId
  //     );
  //     setAttachmentList(newAttachmentList);
  //     if (newAttachmentList.length > 0) {
  //       setSelectedAttachment(newAttachmentList[0]);
  //     } else {
  //       setSelectedAttachment(null);
  //     }
  //   }
  // };

  return (
    <div>
      <div
        style={{
          height: "200px",
          width: "200px",
          padding: 5,
          border: "1px solid rgba(128,128,128,0.5)",
          margin: 3,
        }}>
        <AttachmentViewer attachmentId={selectedAttachment?.attachmentId} />
      </div>
      {attachmentList.length > 1 && (
        <div className="spaceBetween" style={{ width: "100%" }}>
          <IconButton onClick={prevAttachment} disabled={currentIndex === 0}>
            <PrevIcon />
          </IconButton>
          <div>
            {currentIndex + 1}/{attachmentList.length}
          </div>
          <IconButton
            onClick={nextAttachment}
            disabled={currentIndex + 1 === attachmentList.length}>
            <NextIcon />
          </IconButton>
        </div>
      )}
      {/* {attachmentList.length > 0 && (
        <Select size="small">
          <MenuItem onClick={() => deleteAttachment(selectedAttachment?.attachmentId)}>
            <DeleteIcon fontSize="small" /> Poista liite
          </MenuItem>
        </Select>
      )} */}
    </div>
  );
}
